module.exports = __webpack_public_path__ + "assets/img/flamengo5.50de71c6.png";